<template>
  <div class="filter-multiple">
    <div
      v-for="(_, id) in statusList"
      :key="id"
      class="filter-multiple__item"
      :class="{ active: isActive(id) }"
      @click="changeSelected(id)"
    >
      <status-title :status="parseInt(id, 10)" :status-list="statusList"></status-title>
    </div>
  </div>
</template>

<script>
import('@/styles/components/filter.less')

export default {
  name: 'StatusFilter',
  components: {
    StatusTitle: () => import('@/components/StatusTitle.vue')
  },
  model: {
    prop: 'statuses'
  },
  props: {
    statuses: {
      type: [Array, Number],
      required: false
    },
    statusList: {
      type: Object,
      required: true
    },
    isMultiple: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    localStatuses: []
  }),
  mounted() {
    if ((this.isMultiple && this.statuses.length > 0) || (!this.isMultiple && this.statuses)) {
      this.setLocalStatus()
    }
  },
  watch: {
    statuses() {
      this.setLocalStatus()
    }
  },
  methods: {
    setLocalStatus() {
      if (this.isMultiple) {
        this.localStatuses = this.statuses.slice().map(status => parseInt(status, 10))
      } else {
        this.localStatuses = this.statuses
      }
    },
    changeSelected(status) {
      const id = parseInt(status, 10)
      if (this.isMultiple) {
        const index = this.localStatuses.indexOf(id)
        if (index === -1) {
          this.localStatuses.push(id)
        } else {
          this.localStatuses.splice(index, 1)
        }
      } else {
        this.localStatuses = id
      }
      this.$emit('input', this.localStatuses)
    },
    isActive(status) {
      if (this.isMultiple) {
        return this.localStatuses.indexOf(parseInt(status, 10)) !== -1
      } else {
        return this.localStatuses === parseInt(status, 10)
      }
    }
  }
}
</script>
